import {
  SelectableTable,
  WbMultiSelectionPickerDrawer,
  WbTableFilters,
} from '@agilelab/plugin-wb-platform';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { FC, useEffect, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { rbacApiRef } from '../../../plugin';
import { Filters } from '../Roles/RolesTableContext';

export interface PermissionEntity {
  id: string;
  displayName: string;
  description?: string;
  scope?: string;
}
import { useRolePermissionsTableContext } from './RolePermissionsTableContext';

export const RolePermissionsDrawer: FC = () => {
  const rbacApi = useApi(rbacApiRef);
  const identityApi = useApi(identityApiRef);
  const {
    selectedPermissions,
    setSelectedPermissions,
    defaultColumns,
    openManageDrawer,
    updateRole,
    setOpenManageDrawer,
  } = useRolePermissionsTableContext();

  const [allPermissionsFilters, setAllPermissionsFilters] = useState<Filters>(
    {},
  );
  const [platformPermissionsState, loadPlatformPermissions] =
    useAsyncFn(async () => {
      const result = await rbacApi.getPlatformPermissions({
        searchKeyword: allPermissionsFilters.text,
        options: {
          token: (await identityApi.getCredentials()).token,
        },
      });

      return result.permissions.map(p => ({
        ...p,
        displayName: p.displayName ?? p.id,
      }));
    }, [allPermissionsFilters]);

  useEffect(() => {
    loadPlatformPermissions();
  }, [loadPlatformPermissions]);

  const getRowId = (row: PermissionEntity) => row.id;

  return (
    <WbMultiSelectionPickerDrawer<PermissionEntity>
      open={openManageDrawer}
      setOpen={setOpenManageDrawer}
      title="Manage permissions"
      selectedValues={selectedPermissions}
      setSelectedValues={setSelectedPermissions}
      contentHeader={<></>}
      onApply={updateRole}
    >
      <WbTableFilters
        style={{ marginBottom: '0', paddingLeft: '8px' }}
        searchValue={allPermissionsFilters.text}
        onSearch={search => {
          setAllPermissionsFilters({ text: search });
        }}
        onClear={() => setAllPermissionsFilters({})}
      />
      <SelectableTable<PermissionEntity>
        loading={platformPermissionsState.loading}
        data={platformPermissionsState.value ?? []}
        columns={defaultColumns}
        getRowId={getRowId}
      />
    </WbMultiSelectionPickerDrawer>
  );
};
